/**
 * Migration Utility: Clear old localStorage data
 * 
 * This script should be run once to migrate from localStorage to sessionStorage
 * and clear any old token data from localStorage.
 * 
 * Call this in your app initialization (e.g., in index.js or App.js)
 */

export const migrateFromLocalStorage = () => {
  try {
    // Check if there's old data in localStorage
    const oldAccessToken = localStorage.getItem('accessToken');
    const oldRefreshToken = localStorage.getItem('refreshToken');
    const oldUser = localStorage.getItem('user');

    if (oldAccessToken || oldRefreshToken || oldUser) {
      console.warn('Found old token data in localStorage. Migrating to sessionStorage...');
      
      // Clear old localStorage data
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      
      console.log('Old localStorage data cleared. Please login again.');
      
      // Optionally, you could migrate the data to sessionStorage
      // But it's safer to force re-authentication
      return false; // Indicates migration happened, user needs to re-login
    }
    
    return true; // No migration needed
  } catch (error) {
    console.error('Error during storage migration:', error);
    return true;
  }
};

/**
 * Clear all storage (both localStorage and sessionStorage)
 * Useful for debugging or complete logout
 */
export const clearAllStorage = () => {
  try {
    // Clear localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    
    // Clear sessionStorage
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('user');
    
    // Clear memory fallbacks
    delete window.__accessToken;
    delete window.__refreshToken;
    delete window.__user;
    
    console.log('All storage cleared');
  } catch (error) {
    console.error('Error clearing storage:', error);
  }
};
